// Diamond flag with a CSS-only tooltip that lists the escalation reasons.
// Renders nothing if the reasons list is empty — caller doesn't have to guard.

interface Props {
  reasons: string[];
}

export function EscalationFlag({ reasons }: Props) {
  if (!reasons || reasons.length === 0) return null;
  const tooltip = reasons.map((r) => r.replace(/_/g, ' ')).join(' · ');
  return (
    <span className="escalation-flag" data-tooltip={tooltip} aria-label={`escalated: ${tooltip}`}>
      <span className="escalation-flag__mark" aria-hidden="true">◆</span>
      <span className="escalation-flag__tooltip">{tooltip}</span>
    </span>
  );
}
